import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-info-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-dialog.component.html',
  styleUrl: './info-dialog.component.scss'
})
export class InfoDialogComponent implements OnChanges {
  @Input() infoDialogType!: string
  @Output() closeInfoDialog = new EventEmitter<boolean>()

  title = ''
  description = ''
  iconSrc = ''
  buttonText = ''

  ngOnChanges(){
    this.title = this.infoDialogType === 'contactProfile' ? 
      $localize `:Title when a user not registered wants to contact a suggested profile in the info dialog@@UNLIMITED_DIRECT_MESSAGE:Unlimited direct messages` : 
      $localize `:Title when a user not registered wants to like a suggested profile in the info dialog@@UNLIMITED_LIKE:Unlimited likes`
    this.description = this.infoDialogType === 'contactProfile' ? 
      $localize `:Description to invite the user to subscribe to like profiles unlimitedly in the info dialog@@ACTIVATE_PREMIUM_ACCOUNT_MESSAGE:Activate your premium account and send on unlimited direct messages to all profiles of your choice!` : 
      $localize `:Description to invite the user to subscribe to contact profiles unlimitedly in the info dialog@@ACTIVATE_PREMIUM_ACCOUNT_LIKE:Activate your premium account and like on unlimited all profiles of your choice!`
    this.iconSrc = this.infoDialogType === 'contactProfile' ? 'assets/icons/icon_message.svg' : 'assets/icons/icon_love_32.svg'
    this.buttonText = $localize `:Text for the button to redirect to the landing page of the service in the info dialog@@DISCOVER:Discover`
  }

  closeDialog(){
    this.closeInfoDialog.emit(true)
  }
}
